export class logingReq {
  username: string;
  password: string;
}
